'use client';

import dynamic from 'next/dynamic';
import { TFeedbackProps } from './index';

export const DynamicFeedback = dynamic<TFeedbackProps>(
  () => import('./index').then((mod) => mod.Feedback),
  {
    ssr: false,
  },
);
